import React, { FunctionComponent, useRef, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { useBillStyles } from "./useBillStyles";
var converter = require('number-to-words');

type WithBillPaymentDetails = {
    billDetails: any;
    creditCardDetails: Array<object>;
    creditCardAvailable: boolean;    
}
export const BillPaymentDesk: FunctionComponent<WithBillPaymentDetails> = ({
    billDetails,
    creditCardAvailable,
    creditCardDetails   
}) => {
    const classes = useBillStyles();
    const numberToWordsConversion = (total_amount: any) => {
        const words = total_amount.split('.')
        const amountWords = converter.toWords(words[0]);
        const decimalWords = converter.toWords(words[1]);
        if (decimalWords === "zero") {
            return `${(amountWords).replace(/\b\w/g, (l: any) => l.toUpperCase())}
            Riyral Only`
        }
        else {
            return `${(amountWords).replace(/\b\w/g, (l: any) => l.toUpperCase())}
          Riyral and ${(decimalWords).replace(/\b\w/g, (l: any) => l.toUpperCase())} Dirhams Only`
        }
    }

    return (
        <div>
            {/* if discount_amount or discount_percent exist */}
            {
                billDetails && billDetails.find((a: any) => a.discount_amount && a.discount_percent) !== undefined ?
                    billDetails && billDetails.find((a: any) => a.discount_amount !== "0.00" || a.discount_percent !== "0.00") ?
                        <Grid container
                            direction="row"
                            justify="flex-start">

                            <Grid item xs={3}>
                                <Typography
                                    className={classes.billPaymentTypeStyle}
                                >
                                    {billDetails && billDetails.find((a: any) => a.discount_amount) !== undefined ?
                                        billDetails && billDetails.find((a: any) => a.discount_amount !== "0.00") ?
                                            "Discount Amount " : "Discount Percent"
                                        : " "
                                    }
                                </Typography>
                            </Grid>
                            <Grid item xs={1} >
                                <Typography
                                    className={classes.billPaymentValueStyle}
                                >
                                    {
                                        billDetails && billDetails.find((a: any) => a.discount_amount && a.discount_percent) !== undefined ?
                                            billDetails && billDetails.find((a: any) => a.discount_amount !== "0.00") ?
                                                billDetails && billDetails.find((a: any) => a).discount_amount :
                                                billDetails && billDetails.find((a: any) => a.discount_percent !== "0.00") ?
                                                    billDetails && billDetails.find((a: any) => a).discount_percent : " "
                                            : " "
                                    }
                                </Typography>
                            </Grid>
                            <Grid item xs={8}></Grid>
                        </Grid>
                        :
                        <Grid item xs={6}>{" "}</Grid>
                    : ""
            }
            {/* if credit card exist */}

            {
                creditCardAvailable
                    ? creditCardDetails &&
                    creditCardDetails.map((
                        cardDetails: any //if multiple credit card present make it array<object>
                    ) => (
                        <Grid container
                            direction="row"
                            justify="flex-start">

                            <Grid item xs={3}>
                                <Typography
                                    className={classes.billPaymentTypeStyle}
                                >
                                    {cardDetails.creditcard_type}{" "}
                                </Typography>
                            </Grid>
                            <Grid item  >
                                <Typography
                                    className={classes.billPaymentValueStyle}
                                >
                                    {
                                        cardDetails.creditcard_amount
                                    }
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={8}></Grid> */}
                        </Grid>
                    ))
                    : " "
            }
            {/* if foreign key exist */}

            {/* if cash transfer exist */}
            {
                billDetails && billDetails.find((a: any) => a.is_cashreceived) !== undefined ?
                    billDetails && billDetails.find((a: any) => a.is_cashreceived === true) ?
                        <Grid container
                            direction="row"
                            justify="flex-start">

                            <Grid item xs={3}>
                                <Typography
                                    className={classes.billPaymentTypeStyle}
                                >
                                    CASH
                                </Typography>
                            </Grid>
                            <Grid item  >
                                <Typography
                                    className={classes.billPaymentValueStyle}
                                >
                                    {
                                        billDetails && billDetails.find((a: any) => a.total_received) !== undefined ?
                                            billDetails && billDetails.find((a: any) => a).total_received
                                            :
                                            " "
                                    }
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={8}></Grid> */}
                        </Grid>
                        :
                        <Grid item xs={6}>{" "}</Grid>
                    : ""
            }
           
           {/* if credit customer exist */}

           {
                billDetails && billDetails.find((a: any) => a.is_customercredit) !== undefined ?
                    billDetails && billDetails.find((a: any) => a.is_customercredit === true) ?
                        <Grid container
                            direction="row"
                            justify="flex-start">

                            <Grid item xs={3}>
                                <Typography
                                    className={classes.billPaymentTypeStyle}
                                >
                                    CREDIT
                                </Typography>
                            </Grid>
                            <Grid item  >
                                <Typography
                                    className={classes.billPaymentValueStyle}
                                >
                                    {
                                        billDetails && billDetails.find((a: any) => a.total_amount) !== undefined ?
                                            billDetails && billDetails.find((a: any) => a).total_amount
                                            :
                                            " "
                                    }
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={8}></Grid> */}
                        </Grid>
                        :
                        <Grid item xs={6}>{" "}</Grid>
                    : ""
                   
            }
           
            {/* if round off exist */}
            {
                billDetails && billDetails.find((a: any) => a.roundoff_amound) !== undefined ?
                    billDetails && billDetails.find((a: any) => a.roundoff_amound !== '0') ?
                        <Grid container
                            direction="row"
                            justify="flex-start">

                            <Grid item xs={3}>
                                <Typography
                                    className={classes.billPaymentTypeStyle}
                                >
                                    Round off
                                </Typography>
                            </Grid>
                            <Grid item  >
                                <Typography
                                    className={classes.billPaymentValueStyle}
                                >
                                    {
                                        billDetails && billDetails.find((a: any) => a.roundoff_amound) !== undefined ?
                                            billDetails && billDetails.find((a: any) => a).roundoff_amound
                                            :
                                            " "
                                    }
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={8}></Grid> */}
                        </Grid>
                        :
                        <Grid item xs={6}>{" "}</Grid>
                    : ""
            }

            {/* if total amount paid */}

            {
                billDetails && billDetails.find((a: any) => a.total_amount) !== undefined ?

                    <Grid container
                        direction="row"
                        justify="flex-start">

                        <Grid item xs={3}>
                            <Typography
                            style={{ fontWeight: "bold" }}
                                className={classes.billPaymentTypeStyle}
                            >
                                NET TOTAL
                                </Typography>
                        </Grid>
                        <Grid item >
                            <Typography
                                style={{ fontWeight: "bold" }}
                                className={classes.billPaymentValueStyle}
                            >
                                {
                                    billDetails && billDetails.find((a: any) => a.total_amount) !== undefined ?
                                        billDetails && billDetails.find((a: any) => a).total_amount
                                        :
                                        " "
                                }
                              
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography
                                style={{ fontWeight: "bold" }}>
                                {
                                    `(${numberToWordsConversion(billDetails && billDetails.find((a: any) => a.total_amount) !== undefined ?
                                        billDetails && billDetails.find((a: any) => a).total_amount
                                        :
                                        " "
                                    )})`
                                }
                            </Typography>
                        </Grid>
                    </Grid>

                    :
                    <Grid item xs={6}>{" "}</Grid>

            }

        </div>
    )
}